export const getHeader = () => ({
  'Accept': 'application/json',
  'Content-Type': 'application/json;charset=UTF-8',
  'Authorization': 'Basic Y2tfM2FiMjliNjUzNGRkMmVkOGE2NGRiMTgzODYxNTkwMzAyODZiNzJiNjpjc180NzIyZTEyZjJkZGJhNzdhNzBhNjQ0NTU4YTUyODM1MGE1ZDIyMTY2',
});

export const getFieldId = (field) => {
  let fieldId;

  switch(field.type.toLowerCase()) {
    case 'checkbox':
      fieldId = `choice_${field.databaseId}`;
      break;
    default:
      fieldId = `input_${field.databaseId}`;
  }

  return fieldId;
}
